'use client';

import {useEffect} from 'react';
import {useRouter} from 'next/navigation';

export default function IntegrationsRedirectPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/platform/integration-marketplace/');
  }, [router]);

  return (
    <p>
      Redirecting to <a href="/platform/integration-marketplace/">Integration Marketplace</a>...
    </p>
  );
}